export const scrollToElementById = (id: string, offset: number = 0) => {
    const targetElement = document.getElementById(id);

    if (targetElement) {
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: targetPosition + offset,
            behavior: 'smooth',
        });
    }
};

export const scrollToElement = (targetPostitionElement: HTMLElement | Element, offset: number = 0) => {
    if (!targetPostitionElement) return;

    const targetPosition = targetPostitionElement.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
        top: targetPosition + offset,
        behavior: 'smooth',
    });
};
